"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FreeDiagnosisCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={ref} className={`
        py-16 px-4 sm:px-6 lg:px-8
        bg-dark-background
        transition-opacity duration-[var(--duration-medium)]
        ${isVisible ? "opacity-100" : "opacity-0"}
      `}>
      <div className={`
          max-w-3xl mx-auto
          flex flex-col items-center justify-center gap-6
          text-center
          transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
          hover:scale-[1.02]
        `}>
        <p className="text-foreground-dark text-lg sm:text-xl lg:text-2xl font-medium leading-relaxed">¿Listo para reducir los tiempos de limpieza en altura y eliminar riesgos humanos? Solicite su diagnóstico gratuito hoy mismo y descubra cómo nuestros drones pueden transformar su limpieza exterior.</p>

        <Link to="/ContactPage">
          <Button size="lg" className="
              bg-accent text-foreground-accent
              hover:bg-accent-hover hover:shadow-strong hover:-translate-y-0.5
              active:bg-accent-active active:translate-y-0
              transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]
              px-8 py-4 text-base sm:text-lg font-semibold
            ">
            Solicitar diagnóstico gratuito
          </Button>
        </Link>
      </div>
    </section>;
}